import React, { useContext, useEffect, useState } from "react";
import { Segmented } from "antd";

import { GlobalContext } from "./GlobalContext";

const LanguageSwitcher = () => {
    const { language, setLanguage } = useContext(GlobalContext);
    const [languageSet, setLanguageSet] = useState(false);

    const handleChange = (value) => {
        localStorage.setItem("language", value);
        setLanguage(value);
    };

    useEffect(() => {
        // get language from local storage
        const lang = localStorage.getItem("language");

        if (lang && !languageSet) {
            setLanguage(lang);
            setLanguageSet(true);
        }
    }, [languageSet, setLanguageSet, setLanguage]);

    return (
        <Segmented
            value={language}
            defaultValue={language ?? "jp"}
            onChange={handleChange}
            options={[
                { value: "jp", label: "日本語" },
                { value: "en", label: "English" },
            ]}
        />
    );
};

export default LanguageSwitcher;
